// Elements
require("webstrap/type");
require("webstrap/buttons");
require("element/rich-text");
require("grid");

// Styles
require("./jumbotron.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/jumbotron/index.js
 ** module id = 121
 ** module chunks = 0 1
 **/